import PropTypes from 'prop-types'
import { DownloadOutlined } from '@ant-design/icons'
import { Button, message } from 'antd'

import { useDispatch } from 'react-redux'
import { initDownload } from '../../redux/slices/office-check-downloads'
import api from '../../api'

export default function BatchDownloadButton({ practiceId, fromDate, toDate }) {
  const dispatch = useDispatch()

  const downloadBatch = async () => {
    try {
      await api.officeChecks.createBatch(practiceId, fromDate, toDate)
      dispatch(initDownload(practiceId, fromDate, toDate))
    } catch (err) {
      message.error(`Something went wrong: ${err.message}`)
    }
  }

  return (
    <Button icon={<DownloadOutlined />} onClick={downloadBatch}>
      Download All Reports
    </Button>
  )
}

BatchDownloadButton.propTypes = {
  practiceId: PropTypes.string.isRequired,
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired,
}
